import createLocationModel from './lib/create_location_model';

export default createLocationModel({
  modelName: 'Topics',
  properties: {},

  statics: {
    breadcrumb: 'Topics',
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/location/topics.js